import { useMemo } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard  } from '@backstage/core-components';
import { Chip, Box, Typography, Button, makeStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(0.5),
  },
  empty: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export const EntitySpecreqSkillsCard = () => {
  const classes = useStyles();
    const { entity } = useEntity();

    // PARSING LOGIC:
    const skills = useMemo(() => {
      const rawSkills = entity.metadata.annotations?.['specreq/skills'] || '';
      
      return rawSkills
        .split(',')
        .map(s => s.trim().toLowerCase())
        .filter(s => s.length > 0);
    }, [entity]);

  // 3. Helper to open the Source URL (GitHub) for editing
  const sourceLocation = entity.metadata.annotations?.['backstage.io/source-location'] || '';
  const editUrl = sourceLocation.startsWith('url:') ? sourceLocation.slice(4) : undefined;

  return (
    <InfoCard 
      title="Consulting Skills" 
      subheader="Registered expertise for Specreq"
      action={
        editUrl ? (
          <Button 
            color="primary" 
            size="small" 
            href={editUrl} 
            target="_blank"
            startIcon={<EditIcon />}
          >
            Edit in Repo
          </Button>
        ) : undefined
      }
    >
      {skills.length > 0 ? (
        <Box display="flex" flexWrap="wrap">
          {skills.map(skill => (
            <Chip 
              key={skill} 
              label={skill} 
              className={classes.chip} 
              variant="outlined" 
            />
          ))}
        </Box>
      ) : (
        <div className={classes.empty}>
          <Typography variant="body2">
            No skills registered. Add the <code>specreq/skills</code> annotation to your profile YAML.
          </Typography>
        </div>
      )}
    </InfoCard>
  );
};